import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-likert-answer',
  templateUrl: './likert-answer.component.pug',
  styleUrls: ['./likert-answer.component.scss'],
  standalone: false
})
export class LikertAnswerComponent {
  @Input() options:any;
}
